// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>
import api from '../../../services/api';


const validateEmailService = async (data) => {
  return api(
    'https://api.craftyclicks.co.uk/email/1.0/validate',
    data,
    'POST'
  );
};

function validateMobileService(data) {
  return api(
    'https://api.craftyclicks.co.uk/phone/1.1/validate',
    data,
    'POST'
  );
}

const issueVoucherService = async (data) => {
  return api(
    '/Sellitback.svc/IssueVoucher',
    data,
    'POST'
  );
};

export {
  validateEmailService,
  validateMobileService,
  issueVoucherService,
};
